/**
 * AirportMarkers Component - Airport icons on the map
 * Displays airport markers with type-based coloring and popups
 */
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

// Custom airport marker icon creator
export const createAirportIcon = (type) => {
  const color = type === 'military' ? '#dc2626' : type === 'international' ? '#f97316' : '#6b7280';
  return L.divIcon({
    className: 'airport-marker',
    html: `<div style="background-color: ${color}; width: 24px; height: 24px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center;">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
        <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
      </svg>
    </div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12]
  });
};

/**
 * AirportMarkerLayer - Renders all airport markers
 * @param {Array} airports - Array of nearby airport objects
 * @param {boolean} showLayer - Whether to show the layer
 */
export const AirportMarkerLayer = ({ airports, showLayer }) => {
  if (!showLayer || !airports || airports.length === 0) {
    return null;
  }
  
  return (
    <>
      {airports.map((airport) => (
        <Marker 
          key={airport.icao} 
          position={[airport.latitude, airport.longitude]}
          icon={createAirportIcon(airport.type)}
        >
          <Popup>
            <div className="text-sm min-w-[180px]">
              <p className="font-semibold">{airport.icao} – {airport.name}</p>
              <p className="text-slate-500 text-xs">{airport.city}</p>
              <div className="flex items-center gap-2 mt-1.5 pt-1.5 border-t">
                <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ${
                  airport.type === 'military' ? 'bg-red-100 text-red-700' :
                  airport.type === 'international' ? 'bg-orange-100 text-orange-700' :
                  'bg-slate-100 text-slate-600'
                }`}>
                  {airport.type}
                </span>
                <span className="text-xs font-medium">{airport.distance_km} km</span>
              </div>
            </div>
          </Popup>
        </Marker>
      ))}
    </>
  );
};

export default AirportMarkerLayer;
